import {Card, CardContent, Typography, AppBar, Toolbar, Dialog, DialogContent} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { IconButton } from '@material-ui/core';

import { useTranslation} from 'react-i18next';
import useStyles from './styles';

export default function PrivacyPolicy(props) {

    const {isOpen, handleClose} = props;
    const classes = useStyles();
    const {t, i18n} = useTranslation();

    return (

    <Dialog
    open={isOpen}
    onClose={handleClose}
    fullScreen
    className={classes.paper}
    >
    <DialogContent>
    <AppBar
    className={classes.appbar}>
    <Toolbar>
    <IconButton
        edge="start"
        color="inherit"
        onClick={handleClose}
        aria-label="close"
    >
        <CloseIcon />
    </IconButton>

    <Typography variant="h6" component="div">
        {t("titletext", {ns:"privacy"})}
    </Typography>
    </Toolbar>
    </AppBar>

      <Card mb={6} >
        <CardContent>
          <Typography variant="h6" gutterBottom>
             {t("titletext", {ns:"privacy"})}
          </Typography>
          <Typography variant="body2" gutterBottom my={2}>

            {t("effective_date", {ns:"privacy"})}
            <br></br>
            <br></br>

            <Typography variant="h6" gutterBottom>
              {t("section1_title", {ns:"privacy"})}
            </Typography>
            {t("section1_content", {ns:"privacy"})}
            <br></br>
            <br></br>

            <Typography variant="h6" gutterBottom>
              {t("section2_title", {ns:"privacy"})}
            </Typography>
            {t("section2_content", {ns:"privacy"})}
            <br></br>
            <br></br>

            <Typography variant="h6" gutterBottom>
              {t("section3_title", {ns:"privacy"})}
            </Typography>
            {t("section3_content", {ns:"privacy"})}
            <br></br>
            <br></br>

            <Typography variant="h6" gutterBottom>
              {t("section4_title", {ns:"privacy"})}
            </Typography>
            {t("section4_content", {ns:"privacy"})}
            <br></br>
            <br></br>

            <Typography variant="h6" gutterBottom>
              {t("section5_title", {ns:"privacy"})}
            </Typography>
            {t("section5_content", {ns:"privacy"})}
            <br></br>
            <br></br>

            <Typography variant="h6" gutterBottom>
              {t("section6_title", {ns:"privacy"})}
            </Typography>
            {t("section6_content", {ns:"privacy"})}
            <br></br>
            <br></br>

            <Typography variant="h6" gutterBottom>
              {t("section7_title", {ns:"privacy"})}
            </Typography>
            {t("section7_content", {ns:"privacy"})}
            <br></br>
            <br></br>

            {t("contact_info", {ns:"privacy"})}

          </Typography>

        </CardContent>
      </Card>
      </DialogContent>
    </Dialog>
    );
  }
